import { lazy } from 'react';

const CharityVettingPliRoute = lazy(
  () => import(/* webpackChunkName: "Pli" */ '../components/steps/pli-step/Pli'),
);

export default CharityVettingPliRoute;
